'use client'

import Image from 'next/image'

import Shared from '@/shared'
import Button from '@/shared/components/button/Button'
import { Text } from '@/shared/components/typography'

import { NetworkError } from '@/lib/axiosClient'

export default function Error({ error }: ErrorProps) {
  if (window) {
    if (!(error instanceof NetworkError)) {
      const unknownError = new Shared.Errors.UnknownError((error as Error).message)

      if (window.DD_LOGS) {
        window.DD_LOGS.logger.error(unknownError.message, undefined, unknownError)
      }
      if (window.Rollbar) {
        window.Rollbar?.error(unknownError, error)
      }
    }
  }
  const clickRefresh = () => {
    window.location.reload()
  }

  const errorMessage = error.message ? error.message : '문제가 발생했습니다.'

  return (
    <div className="absolute left-0 top-0 flex h-full w-full flex-1 flex-col bg-010">
      <div className="mb-9 flex w-full flex-1 flex-col items-center justify-center gap-3">
        <Text level="text1" color="text090" weight="bold">
          {errorMessage}
        </Text>
        <Text level="text1" color="text090" weight="bold">
          다시 시도해 주세요.
        </Text>
        <Image
          src="/images/light_img_noID_large.svg"
          alt="에러페이지"
          width={0}
          height={0}
          style={{ width: '70%', height: 'auto' }}
        />
      </div>
      <div className="sticky bottom-0 px-4 pb-3">
        <Button
          text="새로고침하기"
          color="text010"
          background="bg030"
          className="body-1"
          disabled={false}
          onClick={() => clickRefresh()}
        />
      </div>
    </div>
  )
}

interface ErrorProps {
  error: Error
  reset: () => void
}
